import { locationActions } from "./locationSlice";
import { AppDispatch, AppThunk } from "../../store";
import { apiFetch } from "../../../utils/api";

export const fetchStates = (): AppThunk => async (dispatch: AppDispatch) => {
  try {
    dispatch(locationActions.startLoading());
    const data = await apiFetch("/api/location/states");

    dispatch(locationActions.setStates(data));
  } catch (error: any) {
    dispatch(
      locationActions.setError(error.message || "Failed to load states")
    );
  } finally {
    dispatch(locationActions.endLoading());
  }
};

export const fetchLgasByState =
  (stateId: number): AppThunk =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(locationActions.startLoading());
      const data = await apiFetch(`/api/location/states/${stateId}/lgas`);
      dispatch(locationActions.setLgas(data));
    } catch (error: any) {
      dispatch(
        locationActions.setError(error.message || "Failed to load LGAs")
      );
    } finally {
      dispatch(locationActions.endLoading());
    }
  };
